import * as React from 'react';
import * as styles from './styles.css';

export interface ISectionProps {
  marginTop?: number;
  marginBottom?: number;
  children: React.ReactNode | React.ReactNode[];
  ref?: React.Ref<HTMLDivElement>;
}

/** Проблема: рендерит обертку div, даже если дочерний элемент внутри себя возвращает null.
 * приводит к тому, что в DOM бывают пустые div’ы */
export function Section({ marginTop, marginBottom, children, ref }: ISectionProps): React.JSX.Element {
  return (
    <div ref={ref} className={styles['container']} style={{ marginTop, marginBottom }}>
      {children}
    </div>
  );
}
